/** Strip tags; package descriptions may be HTML from CMS. */
export function plainTextFromPackageDescription(html) {
  if (html == null || String(html).trim() === '') return '';
  return String(html)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** One line for menus / chips: description + reporting message. */
export function packageDetailSummary(pkg) {
  if (!pkg) return '';
  const parts = [];
  const d = plainTextFromPackageDescription(pkg.description);
  if (d) parts.push(d);
  const r = String(pkg.reportingMessage || '').trim();
  if (r) parts.push(r);
  return parts.join(' · ');
}
